import { addNotification } from 'actions/notification-actions'
import { useAppDispatch } from 'hooks/useAppDispatch'

export const useAddNotification = () => {
  const dispatch = useAppDispatch()
  return (text, type = 'success') => {
    dispatch(addNotification(text, type))
  }
}
